/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */

/* eslint-disable promise/catch-or-return */
'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback, Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { List, Set as ImmutableSet, Record } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJXMessage from 'I18n/components/FormattedJSXMessage';
import Small from 'UIComponents/elements/Small';
import H2 from 'UIComponents/elements/headings/H2';
import UILink from 'UIComponents/link/UILink';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIMultiColumn from 'UIComponents/layout/UIMultiColumn';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import UIToggle from 'UIComponents/input/UIToggle';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIList from 'UIComponents/list/UIList';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIBox from 'UIComponents/layout/UIBox';
import FacebookPixelSelect from 'ads-account-connection/components/FacebookPixelSelect';
import FacebookDataSyncModal from 'ads-account-connection/components/FacebookDataSyncModal';
import OAuthHandler from 'ads-account-connection/components/OAuthHandler';
import AccountConnectionData from 'ads-account-connection/data/AccountConnectionData';
import VisitorDataSelection, { REQUIRED_VISITOR_DATA, VISITOR_DATA, IP_ADDRESS_ENABLED } from 'ads-account-connection/components/VisitorDataSelection';
import PrivacyAndConsentSection, { COOKIES_OPTIONS } from 'ads-account-connection/components/PrivacyAndConsentSection';
import { FB_CONVERSION_API_LEARN_MORE_LINK } from 'ads-account-connection/lib/Constants';
import Networks from 'ads-account-connection/lib/Networks';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import PortalIdParser from 'PortalIdParser';
import UIUpgradeBanner from 'ui-addon-upgrades/ums/UIUpgradeBanner';
const GENERIC_ERROR_MESSAGE = 'GENERIC_ERROR_MESSAGE';
const WARNING_THRESHOLD = 0.8;

const FacebookPixelModal = ({
  adAccounts,
  loading,
  installPixels,
  onClose,
  onRefreshPixels,
  facebookPixels,
  starterUpgradeData,
  trackEvent,
  defaultSelection,
  eventCount,
  eventLimit,
  isEventCreation,
  onAuth,
  isProOrEnterprise,
  hasFacebookCapiFormEventsUpdates
}) => {
  const [selectedPixel, setSelectedPixel] = useState(defaultSelection || null);
  const [openFBAuthModal, setOpenFBAuthModal] = useState(false);
  const [isAddingPixel, setIsAddingPixel] = useState(false);
  const [syncDataToggle, setSyncDataToggle] = useState(selectedPixel && selectedPixel.sendConversionEvents || false);
  const [externalBusinessId, setExternalBusinessId] = useState('');
  const [error, setError] = useState('');
  const [visitorData, setVisitorData] = useState([...(defaultSelection && defaultSelection.facebookPixelEventFields ? Object.keys(defaultSelection.facebookPixelEventFields).filter(k => defaultSelection.facebookPixelEventFields[k]) : []), // used to improve event conversions
  ...(hasFacebookCapiFormEventsUpdates ? [IP_ADDRESS_ENABLED] : []), ...REQUIRED_VISITOR_DATA]);
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);
  const [showCookieBannerError, setShowCookieBannerError] = useState(false);
  const [cookiesOptionSelected, setCookiesOptionSelected] = useState(COOKIES_OPTIONS.NONE);
  const [userToken, setUserToken] = useState('');
  useEffect(() => {
    if (selectedPixel && selectedPixel.installed) {
      if (selectedPixel.sendAllEventsConsent) {
        setCookiesOptionSelected(COOKIES_OPTIONS.NOT_USING_COOKIE_BANNER);
      } else {
        setCookiesOptionSelected(COOKIES_OPTIONS.USING_COOKIE_BANNER);
      }
    }
  }, [selectedPixel]);

  const getAdAccount = () => adAccounts.find(adAccount => adAccount.accountId === selectedPixel.accountId);

  const limitedDataUseEnabled = selectedPixel && !!getAdAccount() && getAdAccount().limitedDataUseEnabled;
  useEffect(() => {
    if (limitedDataUseEnabled && !visitorData.includes(IP_ADDRESS_ENABLED)) {
      visitorData.push(IP_ADDRESS_ENABLED);
    }
  }, [limitedDataUseEnabled, visitorData]);

  const onVisitorDataChange = data => {
    setVisitorData(data);
  };

  const handleError = useCallback(err => {
    if (err) {
      trackEvent('conversionsEventActions', {
        action: 'Failed to setup FBE auth',
        network: Networks.FACEBOOK,
        isSyncOn: syncDataToggle,
        error: err
      });
    }

    setError(err);
  }, [syncDataToggle, trackEvent]);

  const onSendConversionEvents = (adAccountId, pixelId, enabled) => {
    const payload = {};
    VISITOR_DATA.forEach(option => {
      payload[option] = visitorData.includes(option);
    });
    AccountConnectionData.sendConversionEvents(adAccountId, pixelId, payload, enabled, cookiesOptionSelected !== COOKIES_OPTIONS.USING_COOKIE_BANNER).then(() => {
      onRefreshPixels();
      onClose();
    }).catch(() => {
      setError(GENERIC_ERROR_MESSAGE);
    });
  };

  const onSetupConversionsAPI = () => {
    const visitorPayload = {};
    VISITOR_DATA.forEach(option => {
      visitorPayload[option] = visitorData.includes(option);
    });

    if (selectedPixel && selectedPixel.fbeinstalled) {
      onSendConversionEvents(selectedPixel.accountId, selectedPixel.id, true);
    } else {
      const payload = {
        facebookBusinessExtensionAuth: {
          externalBusinessId,
          userToken,
          adAccountId: selectedPixel.accountId,
          sendAllEventsConsent: cookiesOptionSelected !== COOKIES_OPTIONS.USING_COOKIE_BANNER
        },
        facebookPixelEventFields: visitorPayload
      };
      AccountConnectionData.setupConversionsAPI(payload).then(() => {
        trackEvent('conversionsEventActions', {
          action: 'Successful FBE auth setup',
          network: Networks.FACEBOOK,
          isSyncOn: syncDataToggle
        });
        onRefreshPixels();
        onClose();
      }).catch(() => {
        handleError(GENERIC_ERROR_MESSAGE);
      });
    }
  };

  const onSyncDataToggleChange = () => {
    trackEvent('conversionsEventActions', {
      action: 'Clicked on sync data toggle',
      network: Networks.FACEBOOK,
      isSyncOn: syncDataToggle
    });

    if (syncDataToggle) {
      setSyncDataToggle(false);
      setOpenFBAuthModal(false);
      onSendConversionEvents(selectedPixel.accountId, selectedPixel.id, false);
      return;
    }

    setSyncDataToggle(true);

    if (selectedPixel && !selectedPixel.fbeinstalled) {
      setOpenFBAuthModal(true);
    }
  };

  const onSelectedPixelChange = pixel => {
    setSelectedPixel(pixel);
  };

  const onCookieOptionSelection = option => {
    setCookiesOptionSelected(option);
  };

  const onInstallPixelsConfirmed = () => {
    trackEvent('conversionsEventActions', {
      action: 'Clicked on the Add pixel button',
      network: Networks.FACEBOOK,
      isSyncOn: syncDataToggle,
      selectedData: syncDataToggle ? visitorData : []
    });

    if (syncDataToggle) {
      if (cookiesOptionSelected === COOKIES_OPTIONS.USING_COOKIE_BANNER) {
        AccountConnectionData.hasCookieBannerInfo().then(enabled => {
          if (!enabled) {
            setShowCookieBannerError(true);
            return;
          }

          onSetupConversionsAPI();
        });
      } else if (cookiesOptionSelected === COOKIES_OPTIONS.NOT_USING_COOKIE_BANNER) {
        onSetupConversionsAPI();
      }

      return;
    } // FB business auth is needed for event creation


    if (isEventCreation && !selectedPixel.fbeinstalled) {
      setIsAddingPixel(true);
      setOpenFBAuthModal(true);
      return;
    }

    if (!loading) {
      installPixels(ImmutableSet([selectedPixel]));
    }
  };

  const oAuthSuccess = useCallback(data => {
    const fbeAuthData = {
      externalBusinessId,
      userToken: data.accessToken,
      adAccountId: selectedPixel.accountId
    };
    setShowLoadingSpinner(true);
    setUserToken(data.accessToken);
    onAuth(fbeAuthData);
    setShowLoadingSpinner(false);

    if (isAddingPixel && !loading) {
      installPixels(ImmutableSet([selectedPixel]), fbeAuthData);
    }
  }, [isAddingPixel, installPixels, loading, selectedPixel, onAuth, externalBusinessId]);
  const onOAuthFailure = useCallback(data => {
    setSyncDataToggle(false);
    setError(data.error);
  }, []);

  const onCancelButton = () => {
    trackEvent('conversionsEventActions', {
      action: 'Clicked on the cancel button',
      network: Networks.FACEBOOK,
      isSyncOn: syncDataToggle
    });
    onClose();
  };

  const Link = ({
    children
  }) => {
    return /*#__PURE__*/_jsx(UILink, {
      external: true,
      href: `/settings/${PortalIdParser.get()}/marketing/ads/adAccounts`,
      children: children
    });
  };

  const i18nKey = `ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.syncData.${error}_jsx`;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs(UIModal, {
      width: 550,
      "data-test-id": "install-facebook-pixel-modal",
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.addPixel"
          })
        })]
      }), /*#__PURE__*/_jsxs(UIDialogBody, {
        children: [error && /*#__PURE__*/_jsx(UIAlert, {
          type: "danger",
          closeable: true,
          onClose: () => setError(''),
          children: isValidI18nKey(i18nKey) ? /*#__PURE__*/_jsx(FormattedJXMessage, {
            message: i18nKey,
            elements: {
              Link,
              br: 'br',
              strong: 'strong'
            }
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.syncData.GENERIC_ERROR_MESSAGE"
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "display-flex",
            children: [/*#__PURE__*/_jsx(UIBox, {
              grow: 1,
              children: /*#__PURE__*/_jsx(UIFormControl, {
                label: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.pixelLabel"
                }),
                children: /*#__PURE__*/_jsx("span", {
                  children: /*#__PURE__*/_jsx(FacebookPixelSelect, {
                    adAccounts: adAccounts,
                    facebookPixels: facebookPixels,
                    selectedPixel: selectedPixel,
                    onPixelChange: onSelectedPixelChange,
                    disableInstalled: true,
                    starterUpgradeData: starterUpgradeData,
                    trackEvent: trackEvent,
                    requireAudiencePermissionsToInstall: true,
                    defaultSelection: defaultSelection
                  })
                })
              })
            }), showLoadingSpinner && /*#__PURE__*/_jsx(UIBox, {
              basis: 30,
              shrink: 1,
              alignSelf: "end",
              children: /*#__PURE__*/_jsx(UILoadingSpinner, {
                size: "small"
              })
            })]
          }), !isEventCreation && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("div", {
              className: "m-y-2",
              children: /*#__PURE__*/_jsx(Small, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.description"
                })
              })
            }), isProOrEnterprise && /*#__PURE__*/_jsx(UIMultiColumn, {
              className: "m-top-3",
              children: /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
                children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
                  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.syncData.title"
                  }),
                  children: /*#__PURE__*/_jsxs(Small, {
                    children: [/*#__PURE__*/_jsx(FormattedMessage, {
                      message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.syncData.description"
                    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UILink, {
                      external: true,
                      href: FB_CONVERSION_API_LEARN_MORE_LINK,
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "ADS_ACCOUNT_CONNECTION.conversionsApi.learnMore"
                      })
                    })]
                  })
                }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
                  children: /*#__PURE__*/_jsx(UIToggle, {
                    size: "xs",
                    disabled: !selectedPixel || showLoadingSpinner || eventCount >= eventLimit && !syncDataToggle,
                    checked: syncDataToggle,
                    onChange: onSyncDataToggleChange
                  })
                })]
              })
            }), isProOrEnterprise && /*#__PURE__*/_jsx(UIUpgradeBanner, {
              upgradeKey: "events-offline-usage-limit-index",
              value: eventCount,
              limit: eventLimit,
              displayThreshold: Math.floor(eventLimit * WARNING_THRESHOLD),
              className: "m-bottom-4 p-y-5"
            })]
          }), !isEventCreation && syncDataToggle && /*#__PURE__*/_jsx(UIMultiColumn, {
            style: {
              borderTop: 0
            },
            children: /*#__PURE__*/_jsx(UIMultiColumnGroup, {
              children: /*#__PURE__*/_jsx(UIMultiColumnItem, {
                titleText: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.chooseData.title"
                }),
                children: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(FormattedMessage, {
                    style: {
                      fontWeight: 500
                    },
                    message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.chooseData.selectEvents"
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.chooseData.description"
                    })
                  }), /*#__PURE__*/_jsx(UIList, {
                    children: /*#__PURE__*/_jsx(UICheckbox, {
                      checked: true,
                      disabled: true,
                      children: /*#__PURE__*/_jsx(FormattedMessage, {
                        message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.chooseData.pageViews"
                      })
                    })
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
                    style: {
                      fontWeight: 500
                    },
                    message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.chooseData.selectVisitors"
                  }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.chooseData.selectVisitorsInfo"
                    })
                  }), /*#__PURE__*/_jsx(VisitorDataSelection, {
                    defaultValue: visitorData,
                    onVisitorDataChange: onVisitorDataChange,
                    limitedDataUseEnabled: limitedDataUseEnabled
                  })]
                })
              })
            })
          }), /*#__PURE__*/_jsx(PrivacyAndConsentSection, {
            syncDataToggle: syncDataToggle,
            showCookieBannerError: showCookieBannerError,
            clearCookieBannerError: () => setShowCookieBannerError(false),
            onCookieOptionSelection: onCookieOptionSelection,
            trackEvent: trackEvent,
            cookiesOptionSelected: cookiesOptionSelected
          })]
        })]
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UILoadingButton, {
          loading: loading,
          use: "primary",
          onClick: onInstallPixelsConfirmed,
          disabled: !selectedPixel || syncDataToggle && cookiesOptionSelected === COOKIES_OPTIONS.NONE,
          "data-test-id": "confirm-install-fb-pixel-button",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `ADS_ACCOUNT_CONNECTION.conversionsApi.installFacebookPixelModal.${selectedPixel && selectedPixel.installed ? 'updatePixel' : 'addPixel'}`
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: onCancelButton,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ADS_ACCOUNT_CONNECTION.adAccountConnectModal.cancelButton"
          })
        })]
      })]
    }), openFBAuthModal && /*#__PURE__*/_jsx(FacebookDataSyncModal, {
      adAccountId: selectedPixel.accountId,
      pixelId: selectedPixel.id,
      onClose: () => setOpenFBAuthModal(false),
      onExternalBusinessIdChange: id => setExternalBusinessId(id),
      setError: setError,
      isEventCreation: isEventCreation
    }), externalBusinessId && /*#__PURE__*/_jsx(OAuthHandler, {
      onSuccess: oAuthSuccess,
      onFailure: onOAuthFailure
    })]
  });
};

FacebookPixelModal.propTypes = {
  adAccounts: PropTypes.instanceOf(List).isRequired,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  facebookPixels: PropTypes.object.isRequired,
  starterUpgradeData: PropTypes.object,
  trackEvent: PropTypes.func.isRequired,
  defaultSelection: PropTypes.instanceOf(Record),
  isEventCreation: PropTypes.bool,
  onAuth: PropTypes.func
};
export default FacebookPixelModal;